import React from 'react';
import { Link } from 'react-router-dom';
export function AdultRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-571">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-572">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-573">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-574">
          <Link to="/self-defense-classes-in-farmington-hills-michigan" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-575">
            Adult Self-Defense
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-576">
            Family Classes
          </Link>
          <Link to="/are-martial-arts-for-fitness" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-577">
            Fitness
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-578">
            Programs Overview
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-579">
            Start Trial
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-580">
            Contact
          </Link>
        </div>
      </div>
    </section>;
}